import axiosPrivate from "./axiosPrivate";

const getDetallePerfil = (usuario_id) => {
    return axiosPrivate.get("perfil-detalles", {
        params: {
            usuario_id
        }
    }).then(response => response.data);
};

export default {
    getDetallePerfil
};